import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, onMounted, onUnmounted } from 'vue';
import TransactionRecordDialog from './transaction-record-dialog.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'manage-listings-app',
    setup(__props) {
        const listingId = ref(null);
        const showDialog = ref(false);
        const mode = ref('normal');
        let checkInterval = null;
        // Check window.manageListingsStore for changes (polling approach)
        const checkStoreChanges = () => {
            const store = window.manageListingsStore;
            if (!store)
                return;
            // Only update if values changed
            if (store.selectedListingId !== listingId.value) {
                listingId.value = store.selectedListingId;
            }
            if (store.showTransactionDialog !== showDialog.value) {
                showDialog.value = store.showTransactionDialog;
            }
            if (store.transactionMode !== mode.value) {
                mode.value = store.transactionMode || 'normal';
            }
        };
        // Handle close event from dialog
        const handleCloseDialog = () => {
            showDialog.value = false;
            listingId.value = null;
            mode.value = 'normal';
            // Update window object
            if (window.manageListingsStore) {
                window.manageListingsStore.showTransactionDialog = false;
                window.manageListingsStore.selectedListingId = null;
                window.manageListingsStore.transactionMode = 'normal';
            }
        };
        // Initialize on mount
        onMounted(() => {
            // Initial check
            checkStoreChanges();
            // Poll every 100ms to check for changes
            checkInterval = window.setInterval(checkStoreChanges, 100);
        });
        // Cleanup on unmount
        onUnmounted(() => {
            if (checkInterval) {
                clearInterval(checkInterval);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(TransactionRecordDialog, {
                "listing-id": listingId.value,
                "show-dialog": showDialog.value,
                mode: mode.value,
                onCloseDialog: handleCloseDialog
            }, null, 8, ["listing-id", "show-dialog", "mode"]));
        };
    }
});
